export {
  default,
  BaseWrapper,
  InfoAside,
  SuccessAside,
  WarningAside,
  QuoteAside,
} from './Aside';
